/**
 * @Author: Zero
 * @Date: 2025-11-10 10:32:51
 * @Explain: 测试玩家管理模块
 */
import type {
  ApiPromiseResult,
  FullRegionListResponse,
  GetAreaListData,
} from '@/pages/testerManage/utils/typings/list.d';
import http from '../http';

const MODEL = '/tester';

export default {
  // 测试人列表
  getTesterList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 测试管理列表
  getTesterUserList(data: Record<any, any>) {
    return http.post(`${MODEL}/user_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 删除测试人
  onDelete(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 修改/保存-测试人配置信息
  editTesterInfo(data: Record<any, any>) {
    return http.post(`${MODEL}/save`, data);
  },
  // 获取 测试人管理页面-明细
  getTesterDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 测试人管理页面-导入联系人
  sendTesterImportContact(data: Record<any, any>): ApiPromiseResult {
    return http.post(`${MODEL}/user_import`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 邀请总数
  getTesterInvitationUsersTotal(data: Record<any, any>) {
    return http.post(`${MODEL}/user_invited_total`, data);
  },
  // 发送邀请请求
  sendTesterInvitationUsers(data: Record<any, any>) {
    return http.post(`${MODEL}/user_invite`, data);
  },
  // 发送删除请求
  deleteTesterInvitationList(data: Record<any, any>) {
    return http.post(`${MODEL}/user_delete`, data);
  },
  // 验证-测试人配置信息-title字段是否重复
  checkTitle(data: Record<any, any>) {
    return http.post(`${MODEL}/check_title`, data);
  },
  // 获取所有区域列表
  getFullRegionList(
    data: GetAreaListData = {},
  ): Promise<FullRegionListResponse> {
    return http.post(`/region_group/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
